import { Roles } from "../constants/roles";
import { FormBase } from "../util/form-base-form";

export class HorizontalSliderForm extends FormBase {
    private readonly root: HTMLElement;

    public constructor(root: HTMLElement) {
        super();
        this.root = root;
    }

    public static getRoots(root: ParentNode | Document | HTMLElement = document): HTMLElement[] {
        const form = new HorizontalSliderForm(root instanceof HTMLElement ? root : document.body);
        const roots: HTMLElement[] = [];
        if (root instanceof HTMLElement && root.matches(`[data-role="${Roles.HORIZONTAL_SLIDER}"]`)) {
            roots.push(root);
        }
        form.queryElements(root, `[data-role="${Roles.HORIZONTAL_SLIDER}"]`, HTMLElement).forEach((slider) => {
            if (!roots.includes(slider)) {
                roots.push(slider);
            }
        });
        return roots;
    }

    public getRoot(): HTMLElement {
        return this.root;
    }

    public getTrack(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.HORIZONTAL_SLIDER_TRACK}"]`, HTMLElement);
    }

    public getPrevButton(): HTMLButtonElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.HORIZONTAL_SLIDER_PREV}"]`, HTMLButtonElement);
    }

    public getNextButton(): HTMLButtonElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.HORIZONTAL_SLIDER_NEXT}"]`, HTMLButtonElement);
    }

    public getDotsContainer(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.HORIZONTAL_SLIDER_DOTS}"]`, HTMLElement);
    }

    public getSlides(): HTMLElement[] {
        const track = this.getTrack();
        if (!(track instanceof HTMLElement)) {
            return [];
        }

        return this.queryElements(track, ".home-slide", HTMLElement);
    }

    public getClosestDot(target: EventTarget | Element | null | undefined): HTMLButtonElement | null {
        return this.closest(target, `[data-role="${Roles.HORIZONTAL_SLIDER_DOT}"]`, HTMLButtonElement);
    }

    public isInitialized(): boolean {
        return this.root.dataset.horizontalSliderInit === "1";
    }

    public markInitialized(): void {
        this.root.dataset.horizontalSliderInit = "1";
    }

    public hasFocusedDescendant(): boolean {
        return this.root.contains(document.activeElement);
    }

    public getEdgeMode(): "wrap" | "rotate" {
        const mode = (this.root.dataset.edgeMode || "wrap").trim();
        return mode === "rotate" ? "rotate" : "wrap";
    }
}
